"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventEmitter = require("wolfy87-eventemitter");
const LogManager_1 = require("../Log/LogManager");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const ProtocolConstant_1 = require("./../Protocol/ProtocolConstant");
const Signalling_1 = require("./WebSync/Signalling");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const Session_1 = require("../RtcSession/Session");
const SessionTicket_1 = require("../RtcSession/Protocol/SessionTicket");
const Attendee_1 = require("../RtcSession/Protocol/Attendee");
const SessionDefinition_1 = require("../RtcSession/SessionDefinition");
const LocalMedia_1 = require("./IceLink/LocalMedia");
const ConferenceResource_1 = require("./ConferenceResource");
require("../RtcSession/SessionLogUtil");
const SessionLogUtil_1 = require("../RtcSession/SessionLogUtil");
const IceLink2Utils_1 = require("./IceLink/IceLink2Utils");
class Langyan {
    constructor(parameter) {
        this._logger = LogManager_1.logManager.GetLogger("Langyan");
        this._webSyncServerUrl = "http://61.220.29.158:8090/Langyan/websync.ashx";
        this._iceLinkServerAddress = "61.220.29.158:3478";
        this.LocalMedia = null;
        this._connectedUserName = "";
        //private Certificate: fm.icelink.certificate;
        this.ICE_LINK_RELAY_PASSWORD = "StarWars@Taiwan";
        this._conferenceResDic = new Map();
        this.errorOccurred = new EventEmitter();
        this.onSignalingError = (error) => {
            if (error instanceof Signalling_1.ConnectionNotStableError) {
                this.errorOccurred.emitEvent(exports.LangyanErrorName, new LangyanSignalingNotStableError("Not Stable", error));
            }
            else if (error instanceof Signalling_1.ConnectionNotAvaliableError) {
                this.errorOccurred.emitEvent(exports.LangyanErrorName, new LangyanSignalingNotAvailableError("Not Available.", error));
            }
            else {
                this._logger.error(`Cannot handle this SignallingError`);
            }
        };
        this._signalling = null;
        if (parameter) {
            this.webSyncServerUrl = parameter.webSyncServerUrl;
            this.iceLinkServerAddress = parameter.iceLinkServerAddress;
            this._logger.debug(`using Langyan.WebSync=${this.webSyncServerUrl}, using Langyan.Conference=${this.iceLinkServerAddress}`);
        }
    }
    get webSyncServerUrl() { return this._webSyncServerUrl; }
    set webSyncServerUrl(url) { this._webSyncServerUrl = url; }
    get iceLinkServerAddress() { return this._iceLinkServerAddress; }
    set iceLinkServerAddress(address) { this._iceLinkServerAddress = address; }
    async initAsync(initPara) {
        await this.startSiganllingAsync(initPara.userName, initPara.token, initPara.requestTimeout, initPara.importedWebSync);
        const langyanUser = new LangyanUser({
            userId: initPara.userId,
            userName: initPara.userName,
            authToken: initPara.token
        });
        this._logger.debug(`Starting to bind ${ProtocolConstant_1.RTC_BINDING_LANGYAN_USER_KEY_NAME}=${JSON.stringify({ UserId: langyanUser.userId, UserName: langyanUser.userName })}`);
        await this.bindAsync(ProtocolConstant_1.RTC_BINDING_LANGYAN_USER_KEY_NAME, langyanUser);
        if (initPara.importedIceLink) {
            this._logger.debug(`Using imported IceLink.`);
            this._icelink = initPara.importedIceLink;
        }
    }
    async terminateAsync() {
        if (!this.isConnected())
            return;
        this._logger.info(`Unbinding ${this._connectedUserName}'s ${ProtocolConstant_1.RTC_BINDING_LANGYAN_USER_KEY_NAME} from signaling`);
        await this.unbindAsync(ProtocolConstant_1.RTC_BINDING_LANGYAN_USER_KEY_NAME);
        await this.stopSignallingAsync();
    }
    async startSiganllingAsync(username, token = "", requestTimeout, importedWebsync) {
        this.newSignalling();
        if (this._signalling) {
            await this._signalling.startAsync("", username, token, requestTimeout, importedWebsync);
            this._connectedUserName = username;
        }
    }
    async startSignallingAsync(id, name, requestTimeout, importedWebsync) {
        this.newSignalling();
        if (this._signalling) {
            this._signalling.startAsync(id, "", "", requestTimeout, importedWebsync);
            this._connectedUserName = name;
        }
    }
    newSignalling() {
        if (!this._signalling)
            this._signalling = new Signalling_1.Signalling(this._webSyncServerUrl);
        this._signalling.errorOccurred.addListener(Signalling_1.SignallingErrorName, this.onSignalingError);
    }
    async stopSignallingAsync() {
        this._logger.info("Stopping signalling.");
        if (this._signalling) {
            this._connectedUserName = "";
            this._signalling.errorOccurred.removeListener(Signalling_1.SignallingErrorName, this.onSignalingError);
            await this._signalling.stopAsync();
        }
    }
    isConnected() {
        if (this._signalling) {
            return this._signalling.isConnected();
        }
        else
            return false;
    }
    get connectedUsername() { return this._connectedUserName; }
    async bindAsync(bindingKeyName, bindingObj) {
        if (this._signalling) {
            const bindObjJson = JSON.stringify(bindingObj);
            await this._signalling.bindAsync(bindingKeyName, bindObjJson);
        }
    }
    async unbindAsync(bindingKeyName) {
        if (this._signalling) {
            await this._signalling.unbindAsync(bindingKeyName);
        }
    }
    async subscribeAsync(channelName, channelAsyncHandler, channelBinaryAsyncHandler) {
        if (!this._signalling)
            return {};
        const subscribeResult = await this._signalling.subscribeAsync(channelName, async (isBinary, dataJson, dataBytes) => {
            if (!isBinary) {
                const result = JSON.parse(dataJson);
                await channelAsyncHandler(result);
            }
            else {
                //Langyan doesn't provide binary data transmission.
            }
        });
        if (!subscribeResult) {
            return {};
        }
        else {
            const result = JSON.parse(subscribeResult);
            return result;
        }
    }
    async unSubscribeAsync(channelName) {
        if (this._signalling) {
            await this._signalling.unSubscribeAsync(channelName);
        }
    }
    async requestToServiceAsync(serviceChannelName, dataJson) {
        if (this._signalling == null) {
            const msg = "Signalling is not initialized.";
            this._logger.error(msg);
            throw new LangyanSignalingNotAvailableError("NotAvaliable");
        }
        const result = await this._signalling.requestServiceAsync(serviceChannelName, dataJson);
        if (!result || result === "{}")
            return "";
        else
            return result;
        //return !result ? result : "";
    }
    async publishToChannelAsync(channelName, dataJson) {
        if (this._signalling == null) {
            const msg = "Signalling is not initialized.";
            this._logger.error(msg);
            throw new LangyanSignalingNotAvailableError(msg);
        }
        await this._signalling.publishToChannelAsync(channelName, dataJson);
        return ""; //Publish has no return
    }
    initIceLink(importedIcelink) {
        //IceLink initialization, these can be extracted to ConferenceManager.
        if (importedIcelink) {
            this._logger.debug(`icelink is initialized.`);
        }
        else {
            const globalFm = window.fm;
            if (typeof globalFm === 'undefined')
                throw new LangyanError("No global fm, can not use Conference.");
            const globalIceLink = globalFm.icelink;
            if (typeof globalIceLink === 'undefined')
                throw new LangyanError("No global fm.icelink, No imported fm.icelink, can not start Conference.");
            this._icelink = globalIceLink;
            this._logger.debug(`Using global IceLink.`);
        }
        // To save time, generate a DTLS certificate when the
        // app starts and reuse it for multiple conferences.
        // if (initPara) {
        //   this.Certificate = initPara.importedFm.icelink.certificate.generateCertificate();
        // }
    }
    HasGoingMediaSession() { return false; }
    async StartLocalMeidaAsync(starter, sessionTicket, videoContainer) {
        const doesProvideVideo = this.NeedProvideLocalVideo(starter, sessionTicket);
        const doesProvideAudio = this.NeedProvideLocalAudio(starter, sessionTicket);
        const doesProvidelocalScreenCapature = this.NeedProvideLocalSharingScreen(starter, sessionTicket);
        this.LocalMedia = new LocalMedia_1.LocalMedia(this._icelink, doesProvideVideo, doesProvideAudio, doesProvidelocalScreenCapature);
        //this._logger.debug(`LocalMedia = ${JSON.stringify(this.LocalMedia)}`);
        await this.LocalMedia.StartAsync(videoContainer, sessionTicket.localScreenWidth, sessionTicket.localScreenHeight);
    }
    NeedProvideLocalVideo(starter, st) {
        switch (st.type) {
            case SessionDefinition_1.SessionType.Video: return true;
            case SessionDefinition_1.SessionType.Audio: return false;
            case SessionDefinition_1.SessionType.RemoteVideoAudioOnly: return !st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.LocalVideoAudioOnly: return st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio: return st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.File: return false;
            case SessionDefinition_1.SessionType.SharingScreen: return st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.VideoLive: return st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.AudioLive: return false;
            default: return false;
        }
    }
    NeedProvideLocalAudio(starter, st) {
        switch (st.type) {
            case SessionDefinition_1.SessionType.Video: return true;
            case SessionDefinition_1.SessionType.Audio: return true;
            case SessionDefinition_1.SessionType.RemoteVideoAudioOnly: return !st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.LocalVideoAudioOnly: return st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio: return true;
            case SessionDefinition_1.SessionType.File: return false;
            case SessionDefinition_1.SessionType.SharingScreen: return true;
            case SessionDefinition_1.SessionType.VideoLive: return st.creator.isSame(starter);
            case SessionDefinition_1.SessionType.AudioLive: return true;
            default: return false;
        }
    }
    NeedProvideLocalSharingScreen(starter, st) {
        switch (st.type) {
            case SessionDefinition_1.SessionType.SharingScreen: return st.creator.isSame(starter);
            default: return false;
        }
    }
    AmISessionCreator(localUserName, st) {
        return localUserName === st.creator.name;
    }
    StopLocalMedia(callback) {
        if (this.LocalMedia) {
            this.LocalMedia.Stop(callback);
            this.LocalMedia = null;
        }
        else {
            callback();
        }
    }
    async StartVideoAudioSessionAsync(starter, videoContainer, st, sessionEventCallback) {
        this.initIceLink(this._icelink);
        await this.StartLocalMeidaAsync(starter, st, videoContainer);
        await this.StartAudioVideoConferenceAsync(starter.name, st, undefined, sessionEventCallback);
    }
    async StartAudioSessionAsync(starter, st, sessionEventCallback) {
        this.initIceLink(this._icelink);
        await this.StartLocalMeidaAsync(starter, st, null);
        await this.StartAudioVideoConferenceAsync(starter.name, st, undefined, sessionEventCallback);
    }
    async StartSharingScreenSessionAsync(starter, videoContainer, st, sessionEventCallback) {
        this.initIceLink(this._icelink);
        if (st.creator.isSame(starter)) {
            await this.StartLocalMeidaAsync(starter, st, videoContainer);
        }
        else {
            await this.StartLocalMeidaAsync(starter, st, videoContainer);
        }
        await this.StartAudioVideoConferenceAsync(starter.name, st, undefined, sessionEventCallback);
    }
    async StartDataSessionAsync(starter, st, localDataProvider, remoteDataReceiver, ctor, conferenceEventCallback) {
        this.initIceLink(this._icelink);
        await this.StartDataConferenceAsync(starter.name, st, localDataProvider, remoteDataReceiver, ctor, undefined, conferenceEventCallback);
    }
    async StopSessionAsync(st) {
        await this.StopConferenceAsync(st);
        let isCompleted = false;
        this.StopLocalMedia(() => isCompleted = true);
        await TypeScriptUtils_1.AsyncUtil.AsyncWaitUntil(() => isCompleted);
    }
    async StartAudioVideoConferenceAsync(localUsername, st, sessionChangedCallback, conferenceEventCallback) {
        if (!this._signalling)
            throw new LangyanError("signalling is not initialized.");
        this._logger.info(SessionLogUtil_1.default(this._logger, st, () => "Prepare to start audio video conference."));
        const cr = this.BuildAudioVideoConference(localUsername, st, sessionChangedCallback, conferenceEventCallback);
        this._conferenceResDic.set(st.id, cr);
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Add ConferenceResource, now there are ${this._conferenceResDic.size} ConferenceResource`));
        const needToUseWebSyncExt = this.NeedToUseWebSyncExt(cr.AttachedSessionId);
        await this._signalling.attachAsync(cr.Conference, st.id, needToUseWebSyncExt);
    }
    BuildAudioVideoConference(localUsername, st, sessionChangedCallback, conferenceEventCallback) {
        let attachedSessionId = '';
        if ((st.type === SessionDefinition_1.SessionType.VideoLive || st.type === SessionDefinition_1.SessionType.AudioLive)
            && !this.AmISessionCreator(localUsername, st)) {
            attachedSessionId = st.id + "/send";
        }
        else {
            attachedSessionId = st.id;
        }
        if (!this.LocalMedia)
            throw new LangyanError("No LocalMedia");
        // If a user cancels a stream through some external mechanism
        // (e.g. by clicking the "Stop sharing" button in Chrome),
        // notify the application.
        this.LocalMedia.LocalMediaStream.addOnAudioEnded(async (e) => {
            await this.StopConferenceAsync(st);
        });
        // Create a WebRTC audio stream description (requires a
        // reference to the local audio feed).
        const audioStream = new this._icelink.webrtc.audioStream(this.LocalMedia.LocalMediaStream);
        // If a user cancels a stream through some external mechanism
        // (e.g. by clicking the "Stop sharing" button in Chrome),
        // notify the application.
        this.LocalMedia.LocalMediaStream.addOnVideoEnded(async (e) => {
            await this.StopConferenceAsync(st);
        });
        // Create a WebRTC video stream description (requires a
        // reference to the local video feed). Whenever a P2P link
        // initializes using this description, position and display
        // the remote video control on-screen by passing it to the
        // layout manager created above. Whenever a P2P link goes
        // down, remove it.
        const videoStream = new this._icelink.webrtc.videoStream(this.LocalMedia.LocalMediaStream);
        // Create a new IceLink conference.
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Create fm.icelink.conference with ${this.iceLinkServerAddress}, RelayUsername=${localUsername}`));
        const conference = new this._icelink.conference(this.iceLinkServerAddress, [audioStream, videoStream]);
        const cr = new ConferenceResource_1.ConferenceResource({
            AttachedSessionId: attachedSessionId,
            FromSessionTicket: st,
            //DtlsCertificate: this.Certificate,
            // Supply TURN relay credentials in case we are behind a
            // highly restrictive firewall. These credentials will be
            // verified by the TURN server.
            RelayUsername: localUsername,
            RelayPassword: this.ICE_LINK_RELAY_PASSWORD,
            ConferenceTimeout: 60000,
            DeadStreamTimeout: 30000,
            ConferenceEventCallback: conferenceEventCallback,
            OnConferenceLinkInit: e => {
                // 要可以取得Attendee資訊從Binding裡面
                const idName = IceLink2Utils_1.IceLink2Utils.GetPeerIdName(e);
                const attendee = Attendee_1.Attendee.from(idName.Item1, idName.Item2);
                this.LogLinkInit(e, st, attendee);
                if (conferenceEventCallback)
                    conferenceEventCallback(st, Session_1.SessionInternalEvent.OnLinkWithAttendeeInit, Attendee_1.Attendee.Nobody, {});
            },
            OnConferenceLinkUp: e => {
                const idName = IceLink2Utils_1.IceLink2Utils.GetPeerIdName(e);
                const attendee = Attendee_1.Attendee.from(idName.Item1, idName.Item2);
                this.LogLinkUp(e, st, attendee);
                if (conferenceEventCallback)
                    conferenceEventCallback(st, Session_1.SessionInternalEvent.OneLinkWithAttendeeUp, attendee, {});
                this.HandleConferenceLinkUp(localUsername, e, st, attendee);
            },
            OnConferenceLinkDown: e => {
                const idName = IceLink2Utils_1.IceLink2Utils.GetPeerIdName(e);
                const attendee = Attendee_1.Attendee.from(idName.Item1, idName.Item2);
                this.LogLinkDown(e, st, attendee);
                if (conferenceEventCallback)
                    conferenceEventCallback(st, Session_1.SessionInternalEvent.OneLinkWithAttendeeDown, attendee, {});
                const ssc = new SessionTicket_1.SessionStateChanged(st, e.getException().message);
                if (sessionChangedCallback)
                    sessionChangedCallback(ssc);
            },
            //OnConferenceLinkReceiveRTCP: e => this.HandleConferenceLinkReceiveRTCP(localUsername, e, st),
            OnVideoStreamLinkInit: (e) => this.AddRemoteVideoControl(localUsername, e, st),
            //OnVideoStreamLinkUp: (e) => this.HandleVideoStreamLinkUp(localUsername, e, st),
            OnVideoStreamLinkDown: (e) => this.RemoveRemoteVideoControl(e, st),
        });
        cr.SetupConference(conference);
        cr.SetupVideoStream(videoStream);
        cr.SetupAudioStream(audioStream);
        // force to use relay
        //conference.setSuppressPrivateCandidates(true);
        //conference.setSuppressPublicCandidates(true);
        // force to NOT use relay
        //conference.setSuppressRelayCandidates(true);
        return cr;
    }
    async StartDataConferenceAsync(localUsername, st, localDataProvider, remoteDataReceiver, ctor, sessionChangedCallback, conferenceEventCallback) {
        if (!this._signalling)
            throw new LangyanError("signalling is not initialized.");
        this._logger.info(SessionLogUtil_1.default(this._logger, st, () => "Prepare to start data conference."));
        const cr = this.BuildDataConference(localUsername, st, localDataProvider, remoteDataReceiver, ctor, sessionChangedCallback, conferenceEventCallback);
        this._conferenceResDic.set(st.id, cr);
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Add ConferenceResource, now there are ${this._conferenceResDic.size} ConferenceResource`));
        const needToUseWebSyncExt = this.NeedToUseWebSyncExt(cr.AttachedSessionId);
        await this._signalling.attachAsync(cr.Conference, st.id, needToUseWebSyncExt);
    }
    BuildDataConference(localUsername, st, localDataProvider, remoteDataReceiver, ctor, sessionChangedCallback, conferenceEventCallback) {
        //因為同時有可能有多個DataSession,所以用session.id來幫channel命名,太長再換
        //fm.icelink.webrtc.reliableDataChannel
        const reliableFileDataChannel = new this._icelink.webrtc.reliableDataChannel(false, `reliable_data_channel_${st.id}`);
        //fm.icelink.webrtc.reliableDataReceiveArgs
        reliableFileDataChannel.setOnReceive((reliableDataReceiveArgs) => {
            //收data出錯也不應該Crash，頂多放棄該筆資料
            try {
                //目前先支援JSON字串
                if (reliableDataReceiveArgs.getDataType() === this._icelink.webrtc.reliableDataType.Binary) {
                    this._logger.error(SessionLogUtil_1.default(this._logger, st, () => "Doesn't accept datatype=Binary"));
                    return;
                }
                const dataString = reliableDataReceiveArgs.getDataString();
                //this._logger.debug(BuildSessionLog(this._logger, st, () => `Receving data=${dataString}`));
                if (TypeScriptUtils_1.isNullOrEmpty(dataString)) {
                    this._logger.error(SessionLogUtil_1.default(this._logger, st, () => "Receive empty string, can't processing"));
                    return;
                }
                if (!remoteDataReceiver) {
                    this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => "No remoteDataReceiver, no data will be received."));
                    return;
                }
                const receivedT = JSON.parse(dataString);
                const constructedT = ctor ? new ctor(receivedT) : receivedT;
                //把資料送回去
                remoteDataReceiver.next(constructedT);
            }
            catch (error) {
                this._logger.error(SessionLogUtil_1.default(this._logger, st, () => `Receiving data error, reason=${error.message}`));
            }
        });
        //fm.icelink.webrtc.reliableDataStream
        const dataChannelStream = new this._icelink.webrtc.reliableDataStream([reliableFileDataChannel]);
        // Create a conference using our stream descriptions.
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Create fm.icelink.conference with ${this.iceLinkServerAddress}, RelayUsername=${localUsername}`));
        const conference = new this._icelink.conference(this.iceLinkServerAddress, [dataChannelStream]);
        let dataProviderSubscription = null;
        const cr = new ConferenceResource_1.ConferenceResource({
            AttachedSessionId: st.id,
            FromSessionTicket: st,
            //DtlsCertificate: this.Certificate,
            // Supply TURN relay credentials in case we are behind a
            // highly restrictive firewall. These credentials will be
            // verified by the TURN server.
            RelayUsername: localUsername,
            RelayPassword: this.ICE_LINK_RELAY_PASSWORD,
            ConferenceTimeout: 60000,
            DeadStreamTimeout: 30000,
            ConferenceEventCallback: conferenceEventCallback,
            OnConferenceLinkInit: e => {
                const idName = IceLink2Utils_1.IceLink2Utils.GetPeerIdName(e);
                const attendee = Attendee_1.Attendee.from(idName.Item1, idName.Item2);
                this.LogLinkInit(e, st, attendee);
            },
            OnConferenceLinkUp: e => {
                const idName = IceLink2Utils_1.IceLink2Utils.GetPeerIdName(e);
                const attendee = Attendee_1.Attendee.from(idName.Item1, idName.Item2);
                this.LogLinkUp(e, st, attendee);
                if (conferenceEventCallback)
                    conferenceEventCallback(st, Session_1.SessionInternalEvent.OneLinkWithAttendeeUp, attendee, {});
                if (!localDataProvider) {
                    this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => "No localDataProvider, no data will be sent."));
                    return;
                }
                //Linkup才開始訂閱
                dataProviderSubscription = localDataProvider.subscribe(data => {
                    const dataString = JSON.stringify(data);
                    //this._logger.debug(BuildSessionLog(this._logger, st, () => `Sending data=${dataString}`));
                    const result = conference.sendReliableString(reliableFileDataChannel, dataString);
                    // TODO: conference.sendReliableString always return "false" even the other side received data, Need to investigate the reason.
                    // if (!result) {
                    //   this._logger.error(BuildSessionLog(this._logger, st, () => "Sending Type T error."));
                    // }
                });
            },
            OnConferenceLinkDown: e => {
                const idName = IceLink2Utils_1.IceLink2Utils.GetPeerIdName(e);
                const attendee = Attendee_1.Attendee.from(idName.Item1, idName.Item2);
                this.LogLinkDown(e, st, attendee);
                //訂閱的要釋放
                if (dataProviderSubscription) {
                    dataProviderSubscription.unsubscribe();
                    dataProviderSubscription = null;
                }
                if (conferenceEventCallback)
                    conferenceEventCallback(st, Session_1.SessionInternalEvent.OneLinkWithAttendeeDown, attendee, {});
                const ssc = new SessionTicket_1.SessionStateChanged(st, e.getException().message);
                if (sessionChangedCallback)
                    sessionChangedCallback(ssc);
            },
        });
        cr.SetupConference(conference);
        return cr;
    }
    NeedToUseWebSyncExt(sessionId) {
        return (sessionId.indexOf("/send") === -1);
    }
    async StopConferenceAsync(st) {
        let needToUseWebSyncExt = true;
        //_remoteMediaStreams.Clear();
        if (!this._conferenceResDic.has(st.id)) {
            this._logger.warn(SessionLogUtil_1.default(this._logger, st, () => `No conference can be stopped, ${st}`));
            return;
        }
        const cr = this._conferenceResDic.get(st.id);
        if (!cr)
            return;
        needToUseWebSyncExt = this.NeedToUseWebSyncExt(cr.AttachedSessionId);
        if (this._signalling) {
            await this._signalling.detachAsync(st.id, needToUseWebSyncExt);
        }
        cr.Clear();
        this._conferenceResDic.delete(st.id);
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Remove ConferenceResource, now there are ${this._conferenceResDic.size} ConferenceResource`));
    }
    /**
     *
     *
     * @private
     * @param {string} localUsername
     * @param {fm.icelink.streamLinkInitArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    AddRemoteVideoControl(localUsername, e, st) {
        try {
            //if (!IceLinkUtil.IsHeadlessServer(e))
            {
                const remoteVideoControl = e.getLink().getRemoteVideoControl();
                if (remoteVideoControl && this.NeedToAddRemoteVideoControl(localUsername, st)) {
                    this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Add remote ${IceLink2Utils_1.IceLink2Utils.GetPeerName(e)} video control.`));
                    if (this.LocalMedia)
                        this.LocalMedia.LayoutManager.addRemoteVideoControl(e.getPeerId(), remoteVideoControl);
                }
            }
        }
        catch (error) {
            this._logger.error(SessionLogUtil_1.default(this._logger, st, () => "Could not add video control."), error);
        }
    }
    NeedToAddRemoteVideoControl(localUsername, st) {
        if (st.type === SessionDefinition_1.SessionType.Audio
            || st.type === SessionDefinition_1.SessionType.LocalVideoAudioOnly
            || (st.type === SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio && this.AmISessionCreator(localUsername, st))
            || (st.type === SessionDefinition_1.SessionType.SharingScreen && this.AmISessionCreator(localUsername, st))
            || (st.type === SessionDefinition_1.SessionType.VideoLive && this.AmISessionCreator(localUsername, st))) {
            // 發起Video Live不需要接受別人的Video，目前已把Video Live的觀眾端的Video, Audio關掉，
            // 但做AddRemoteVideoControl會把一個BackScreen加到Video Live發起端這邊，所以需做判斷
            // 最好是能有個ConferenceAction來包裝在不同種類的Conference所需開關的動作。
            return false;
        }
        else {
            return true;
        }
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.streamLinkDownArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    RemoveRemoteVideoControl(e, st) {
        this._logger.info(SessionLogUtil_1.default(this._logger, st, () => "VideoStream Link DOWN"));
        this._logger.info(SessionLogUtil_1.default(this._logger, st, () => "prepare to remove remote video control"));
        try {
            if (this.LocalMedia && this.LocalMedia.LayoutManager) {
                this.LocalMedia.LayoutManager.removeRemoteVideoControl(e.getPeerId());
            }
        }
        catch (error) {
            this._logger.error(SessionLogUtil_1.default(this._logger, st, () => "Could not remote video control."), error);
        }
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkInitArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkInit(e, st, attendee) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Link INIT with ${attendee.name}, ${IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(e)}`));
        //this._logger.debug(BuildSessionLog(this._logger, st, () => `${IceLink2Utils.GenerateLinkRecordDetail(e)}`));
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkUpArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkUp(e, st, attendee) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Link UP with ${attendee.name}, ${IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(e)}`));
        //this._logger.debug(BuildSessionLog(this._logger, st, () => `${IceLink2Utils.GenerateLinkRecordDetail(e)}`));
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkDownArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkDown(e, st, attendee) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => `Link DOWN with ${attendee.name}, ${e.getException()}, ${IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(e)}`));
        //this._logger.debug(BuildSessionLog(this._logger, st, () => IceLink2Utils.GenerateLinkRecordDetail(e)));
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkReceiveRTCPArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkReceiveRTCP(arg, st) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => "Link RECV RTCP, " + IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(arg)));
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkReceiveRTPArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkReceiveRTP(arg, st) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => "Link RECV RTP, " + IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(arg)));
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkReceiveSCTPArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkReceiveSCTP(arg, st) {
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkSendRTCPArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkSendRTCP(arg, st) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => "Link SEND RTCP, " + IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(arg)));
    }
    /**
     *
     *
     * @private
     * @param {fm.icelink.linkSendRTPArgs} e
     * @param {SessionTicket} st
     * @memberof Langyan
     */
    LogLinkSendRTP(arg, st) {
        this._logger.debug(SessionLogUtil_1.default(this._logger, st, () => "Link SEND RTP, " + IceLink2Utils_1.IceLink2Utils.GenerateLinkArgsMessage(arg)));
    }
    /**
     *
     *
     * @private
     * @param {string} localUsername
     * @param {fm.icelink.linkUpArgs} e
     * @param {SessionTicket} st
     * @param {Attendee} attendee
     * @returns {void}
     * @memberof Langyan
     */
    HandleConferenceLinkUp(localUsername, e, st, attendee) {
        try {
            if (!this._conferenceResDic.has(st.id))
                return;
            const confRes = this._conferenceResDic.get(st.id);
            if (!confRes)
                return;
            //新增一筆Link記錄
            confRes.AddLink(e.getPeerId(), attendee);
        }
        catch (error) {
            this._logger.error(SessionLogUtil_1.default(this._logger, st, () => error.message), error);
        }
    }
}
exports.Langyan = Langyan;
class LangyanUser {
    constructor(langyanUser) {
        this.userId = "";
        this.userName = "";
        this.authToken = "";
        if (langyanUser) {
            if (!langyanUser.userId)
                throw new LangyanError('Invalid userId: ' + langyanUser.userId);
            this.userId = langyanUser.userId;
            if (!langyanUser.userName)
                throw new LangyanError('Invalid userName: ' + langyanUser.userName);
            this.userName = langyanUser.userName || this.userName;
            if (!langyanUser.authToken)
                throw new LangyanError('Invalid authToken: ' + langyanUser.authToken);
            this.authToken = langyanUser.authToken || this.authToken;
        }
    }
    isValid() {
        if (this.userId && this.userName)
            return true;
        else
            return false;
    }
}
LangyanUser.INVALID_LANGYAN_USER = new LangyanUser();
exports.LangyanUser = LangyanUser;
exports.LangyanErrorName = "LangyanError";
class LangyanError extends CommonBaseError_1.CommonBaseError {
}
exports.LangyanError = LangyanError;
class LangyanSignalingNotStableError extends LangyanError {
}
exports.LangyanSignalingNotStableError = LangyanSignalingNotStableError;
class LangyanSignalingNotAvailableError extends LangyanError {
}
exports.LangyanSignalingNotAvailableError = LangyanSignalingNotAvailableError;
//# sourceMappingURL=Langyan.js.map